import React from 'react'
import CSSTransitionGroup from 'react-addons-css-transition-group'
import classnames from 'classnames'
import { ProductWithActiveColour } from '../../types'
import { ProductImage } from './ProductImage'
import { ProductPrice } from './ProductPrice'
import { ProductRating } from './ProductRating'
import { ProductSaleTag } from './ProductSaleTag'

interface Props {
  product: ProductWithActiveColour
}

export const ProductBlock: React.FC<Props> = ({ product }) => {
  const permalink = `${product.permalink}?colour=${product.activeColour.ID}`

  const className = classnames('productblock-title', {
    __clearance: product.clearance,
  })

  return (
    <a href={permalink} className="productblock matchheight">
      <div className="productblock-wrap">
        <ProductSaleTag product={product} />
        <ProductRating product={product} />

        <h4 className={className}>{product.title}</h4>

        <ProductPrice product={product} />

        <CSSTransitionGroup
          component="div"
          transitionName="product"
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          <ProductImage product={product} />
        </CSSTransitionGroup>
      </div>

      <div className="productblock-link">
        <span className="button __dark">VIEW PRODUCT</span>
      </div>
    </a>
  )
}
